<span class="created-by">
     <nb-actions fullWidth="false">
    <nb-action *ngIf="logged()==true" size="small">
      <ngx-choose-language></ngx-choose-language>
    </nb-action>
  </nb-actions>
</span>
